import script from "./SearchBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBox.vue?vue&type=script&setup=true&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=ae2181b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae2181b6"]])

export default __exports__